// @flow

import React from 'react';
import { connect } from 'react-redux';

import { Colors } from '@zapier/theme';

import * as Plan from 'app/entities/Plan';
import LinkContainer from 'app/common/components/LinkContainer';
import { EVENT_TRACK_TRIAL_BANNER } from 'app/billing/constants';

type TrialMessageProps = {
  nextPlanAmount: number,
  nextPlanName: string,
  trialDays: number,
};

type MaybeRenderTrialMessageProps = {
  ...$Exact<TrialMessageProps>,
  isLoading: boolean,
};

const TrialMessage = ({
  trialDays,
  nextPlanAmount,
  nextPlanName,
}: TrialMessageProps) => {
  return (
    <span id="trial-message">
      <span style={{ fontWeight: 600 }}>
        Yay! You are now trialing Professional.
      </span>{' '}
      You have {trialDays} days to try out our{' '}
      <LinkContainer
        href="/help/account/billing-pricing/understand-your-zapier-premium-trial"
        style={{
          color: Colors.deepSpace,
        }}
        trackData={{
          in_trial: true,
        }}
        trackMessage={EVENT_TRACK_TRIAL_BANNER}
      >
        premium features
      </LinkContainer>{' '}
      or{' '}
      <LinkContainer
        href={`/app/billing/plans/upgrade/free/${nextPlanName}?interval=year`}
        style={{
          textDecoration: 'none',
        }}
        trackData={{
          in_trial: true,
        }}
        trackMessage={EVENT_TRACK_TRIAL_BANNER}
      >
        upgrade now
      </LinkContainer>{' '}
      for just {nextPlanAmount}/month.
    </span>
  );
};

/**
 * We need to wrap the TrialMessage component into a div before plan details
 * have a chance to load in order to avoid content jumping in the top bar.
 */
const MaybeRenderTrialMessage = ({
  isLoading,
  ...props
}: MaybeRenderTrialMessageProps) => (
  <div>{!isLoading && <TrialMessage {...props} />}</div>
);

const mapStateToProps = (state, props: TrialMessageProps) => ({
  ...props,
  isLoading: Plan.selectors.all.isLoadImpending(state),
});

const TrialMessageContainer = connect(mapStateToProps)(MaybeRenderTrialMessage);

export default TrialMessageContainer;
